import * as types from './settings.types';
import * as constants from './settings.constants';
import { ISettingsUpdate } from '../../resource/settings/settings.types';

export const initialSettingsPage = (): types.IInitialSettingsPage => ({
  type: constants.INITIAL_SETTINGS_PAGE,
});

export const updateSettings = (settings: ISettingsUpdate): types.IUpdateSettings => ({
  type: constants.UPDATE_SETTINGS,
  payload: settings,
});

export const resetPrimaryColors = (): types.IResetPrimaryColors => ({
  type: constants.RESET_PRIMARY_COLORS,
});

export const resetSecondaryColors = (): types.IResetSecondaryColors => ({
  type: constants.RESET_SECONDARY_COLORS,
});

export const storeIsFetched = (): types.IStoreIsFetched => ({
  type: constants.STORE_IS_FETCHED,
});

export const clearIsFetched = (): types.IClearIsFetched => ({
  type: constants.CLEAR_IS_FETCHED,
});

export const fetchWrikeFolderMeetings = (): types.IFetchWrikeFolderMeetings => ({
  type: constants.FETCH_WRIKE_FOLDER_MEETINGS,
});
